<template>

	<div class="loader">

		<transition
			@enter="enterPreloader"
			@leave="leavePreloader"
			:css="false">

			<div class="loader__inner" v-show="showLoader">

				<img class="cloud cloud--1" :src="urlCloud1" width="200" height="108" alt="" ref="cloud1">
				<img class="cloud cloud--2" :src="urlCloud2" width="200" height="76" alt="" ref="cloud2">
				<div ref="fly" id="fly"></div>

				<div class="progress-bar" ref="loadingbar">
					<div class="progress" :style="{ width: width }"></div>
				</div>

			</div>

		</transition>

	</div>

</template>

<script>


import TimelineMax from 'gsap'
import imagesLoaded from 'imagesloaded'

export default {

	data() {

		return {

			maxImg: 0,
			currentImg: 0,
			width: 0,
			urlCloud1: require('../../assets/images/website/img-cloud-loader1.png'),
			urlCloud2: require('../../assets/images/website/img-cloud-loader2.png'),
			showLoader: false

		}

	},

	methods: {

		enterPreloader(el, done) {

			var self = this;

			TweenMax.fromTo(this.$refs.cloud1, 2, 
				{y:4, x: 100, opacity:0, ease: Power1.easeInOut},
				{y:0, x: 0, opacity:0.5, ease: Power1.easeInOut});

			TweenMax.fromTo(this.$refs.cloud2, 2, 
				{y:4, x: -100, opacity:0, ease: Power1.easeInOut},
				{y:0, x: 0, opacity:0.5, ease: Power1.easeInOut});			

			TweenMax.fromTo(this.$refs.fly, 0.5, 
				{y: -50, x: -50, opacity:0, ease: Power1.easeInOut},
				{y: 0, x: 0, opacity:1, ease: Power1.easeInOut, onComplete: function() { self.startPreloader(); }});

			TweenMax.fromTo(this.$refs.loadingbar, 0.5, 
				{y: 10, opacity:0, ease: Power1.easeInOut},
				{y: 0, opacity:1, ease: Power1.easeInOut});

		},

		leavePreloader(el, done) {

			var self = this;

			TweenMax.to(this.$refs.cloud1, 0.3, {y:4, x: 100, opacity:0, ease: Power1.easeInOut});
			TweenMax.to(this.$refs.cloud2, 0.3, {y:4, x: -100, opacity:0, ease: Power1.easeInOut});
			TweenMax.to(this.$refs.fly, 0.3, {y: -50, x: 50, opacity:0, ease: Power1.easeInOut});							
			TweenMax.to(this.$refs.loadingbar, 0.3, {y: 10, opacity:0, ease: Power1.easeInOut, onComplete: function() {

				done();
				self.$store.commit('SHOW_WEBSITE', true)

			}});

		},

		startPreloader() {

			var imgLoad = imagesLoaded( '.bg', { background: '.pl' } );

			imgLoad.on( 'progress', ( instance, image ) => {

				this.maxImg = instance.images.length
				this.currentImg ++

				this.width = (this.currentImg / this.maxImg) * 100 + "%";
				this.$refs.fly.style.marginLeft = Math.round((this.currentImg / this.maxImg) * 100) - 50 +'px';

			});

			imgLoad.on( 'done', ( instance ) => {

				setTimeout(() => { 

					this.showLoader = false;

				}, 500);

			});


		}	

	},

	mounted: function () {

		this.showLoader = true;

	}

}

</script>

<style lang="scss" scoped>

.loader {

	position: fixed;
	width: 100%;
	height: 100%;
	background: linear-gradient(45deg, #4f555a 0%,#2c3239 100%); 
	z-index: 10000;
	left: 0;
	top: 0;

}

.cloud {

	position: absolute;
	opacity: 0.5;

	&--1 {

		left: 50%;
		top: 50%;
		margin-top: -170px;

	}

	&--2 {

		left: 50%;
		top: 50%;
		margin-top: -110px;
		margin-left: -220px;

	}	

}

#fly {
	
	background: url('../../assets/images/website/sprite-vlieg-right.png');
	height: 75px;
	width: 75px;
	display: block;
	position: absolute;
	top: 50%;
	left: 50%;
	margin-top: -100px;
	margin-left: -100px;
	transition: margin-left 1s;
	animation: sprite 1s steps(7) infinite;
}

@keyframes sprite {

	from { background-position: 0 0%; }
	to { background-position: 0 100%; }

}

.progress-bar {

	position: absolute;
	top: 50%;
	left: 50%;
	width: 400px;
	padding: 6px 7px 4px 7px;
	height: 12px;
	background: #b38544;
	border-radius: 20px;
	box-shadow: inset 0px 0px 30px 0px rgba(0,0,0,0.5);
	transform: translateX(-50%) translateY(-50%);

	&:after {

		content: '';
		width: 400px;
		height: 10px;
		background: #c5a256;
		display: block;
		border-radius: 10px;
		position: absolute;
		top: 6px;
		left: 7px;
		z-index: -1;

	}

}

.progress {

	height: 10px;
	border-radius: 10px;
	background: #fffef5;
	transition: width .25s;
	box-shadow: 0px 0px 10px 1px rgba(252,206,71,1), inset 0px 0px 0px 2px rgba(255,242,140,0.8);

}


.touchevents {

	.cloud {

		display: block;

	}

}

</style>


// WEBPACK FOOTER //
// Loader.vue?8e2d0be4